import * as React from "react";
import cs from "classnames";
import PropTypes from "prop-types";
import { Button } from "@lululemon/ecom-pattern-library-button";
import { LoadingIndicator } from "@lululemon/ecom-pattern-library-loading-indicator";

import styles from "../styles/back-in-stock-button.component.module.scss";

const BackInStockBtn = React.forwardRef(function BackInStockButton(
  {
    btnAction,
    btnText,
    className,
    disabled,
    isLoadingBisNotifications,
    ...extraProps
  },
  ref
) {
  return (
    <Button
      block
      className={cs(
        styles.backInStockBtn,
        "OneLinkTx",
        className,
        isLoadingBisNotifications && styles.loading
      )}
      disabled={disabled || isLoadingBisNotifications}
      variant="filled"
      onClick={btnAction}
      ref={ref}
      aria-busy={isLoadingBisNotifications}
      {...extraProps}
    >
      {isLoadingBisNotifications ? (
        <LoadingIndicator color="gray" />
      ) : (
        <>{btnText || <>Sold Out &mdash; Notify Me</>}</>
      )}
    </Button>
  );
});

BackInStockBtn.defaultProps = {
  btnAction: undefined,
  btnText: undefined,
  className: undefined,
  disabled: false
};

BackInStockBtn.propTypes = {
  btnAction: PropTypes.func,
  btnText: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool
};

export default BackInStockBtn;
